"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullOrWhitespace = isNullOrWhitespace;
exports.randomAlphaStr = randomAlphaStr;
exports.urlStrWithoutTrailingSlash = urlStrWithoutTrailingSlash;
exports.commonPrefix = commonPrefix;
exports.getOperandsFromExpression = getOperandsFromExpression;
function isNullOrWhitespace(str) {
    return str === null || str === undefined || str.match(/^ *$/) !== null;
}
const DefaultAlphaNumericDictionary = '0123456789abcdefghijklmnopqrstuvwxyz';
function randomAlphaStr(length, dictionary = DefaultAlphaNumericDictionary) {
    if (length <= 0 || !Number.isInteger(length)) {
        throw new Error('String generator must receive positive integer value: ' + length);
    }
    if (dictionary.length === 0) {
        throw new Error('String generator must receive non-empty dictionary');
    }
    return new Array(length)
        .fill(0, 0, length)
        .map(() => dictionary[Math.floor(Math.random() * dictionary.length)])
        .join('');
}
function urlStrWithoutTrailingSlash(urlStr) {
    while (urlStr.endsWith('/')) {
        urlStr = urlStr.substr(0, urlStr.length - 1);
    }
    return urlStr;
}
function commonPrefix(str1, str2) {
    const minLength = Math.min(str1.length, str2.length);
    for (let i = 0; i < minLength; i++) {
        if (str1[i] !== str2[i]) {
            return str1.substring(0, i);
        }
    }
    return str1;
}
function getOperandsFromExpression(expression) {
    const scientificPlaceholders = [];
    let protectedExpression = expression;
    protectedExpression = protectedExpression.replace(/[eE][+-]\d+/g, (match) => {
        const placeholder = `__SCI_${scientificPlaceholders.length}__`;
        scientificPlaceholders.push({ placeholder, original: match });
        return placeholder;
    });
    const operatorRegex = /[*\-+/()^]/g;
    const operands = protectedExpression
        .split(operatorRegex)
        .map((part) => part.trim())
        .filter((part) => part !== '');
    return operands.map((operand) => {
        let restored = operand;
        scientificPlaceholders.forEach(({ placeholder, original }) => {
            restored = restored.replace(placeholder, original);
        });
        return restored;
    });
}
//# sourceMappingURL=StringUtils.js.map